import { URI_GUARD_REQUEST } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const userToken = rootState['DATA-ACCESS'].userToken;
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'user-token': userToken
    },
    body: JSON.stringify(payload),
  };

  let path = `${URI_GUARD_REQUEST}export-detran-sp`;
  const response = await fetch(path, opts);

  const jsonResult = await response.json();

  if (jsonResult.status === 'error') {
    return Promise.reject(jsonResult.message);
  }
  return jsonResult
};
